export default __webpack_public_path__ + "static/media/bg-myimg5.c1e256a7.jpg";